export default {
    styleOverrides: {
        root: {
            "& span": {
                textTransform: "uppercase"
            }
        }
    }
};
